/**
 * Created by Jession on 2018/04/16.
 * Function 评论管理
 */
import {config, request} from 'Utils';

/* 评论管理列表接口
 * param
    {
      keyword // 关键字筛选
      type  // 评论类型，0为所有类型，1为资讯评论，2为产品评论
      p
      s
    }
*/
export function getCommentList(param) {
  return request(`${config.server}/api/v1/dms/news/getCommentList`,{
    method: 'post',
    body: param
  });
}

/* 批量审核or删除接口
 * param
    [{
      id
      type  // 评论类型：1为资讯评论，2为产品评论
      status  // 审核or删除：0审核，1删除;
    }]
*/
export function approveComments(param) {
  return request(`${config.server}/api/v1/dms/news/approveComments`,{
    method: 'post',
    body: param
  });
}

/* 是否置顶
 * param
    [{
      id
      type  // 评论类型：1为资讯评论，2为产品评论
      status  // 是否置顶：0否，1是
    }]
*/
export function commentTop(param) {
  return request(`${config.server}/api/v1/dms/news/topComments`,{
    method: 'post',
    body: param
  });
}


// WEBPACK FOOTER //
// ./src/service/comment/index.js